import { ViewModel } from "binder";
import { BooleanType, ClassType, DateType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "src/formBuilder/datamodel/structure";
import { BooleanViewModel } from "./boolean/boolean-viewModel";
import { ClassViewModel } from "./class/class-viewModel";
import { DateTimeViewModel } from "./dateTime/dateTime-viewModel";
import { FloatViewModel } from "./float/float-viewModel";
import { IntegerViewModel } from "./integer/integer-viewModel";
import { ListViewModel } from "./list/list-viewModel";
import { ServerSideDataLoaderViewModel } from "./ServerSideDataLoader/serverSideDataLoader-viewModel";
import { StringViewModel } from "./string/string-viewModel";

export interface IDefaultValueManipulator{
    setDefaultValue(defaultValue: any): void;
    getDefaultValue():any;
    
}
export class DefaultValueManipulatorFactory implements IPropertyTypeVisitor{
    private parent:ViewModel;
    create(type:PropertyType,parent:ViewModel) : IDefaultValueManipulator{
        this.parent = parent;
        return type.Accept(this,null);
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return new BooleanViewModel(this.parent);
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return new IntegerViewModel(this.parent);
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return new FloatViewModel(this.parent);
    }
    visitStringType(arg0: StringType, parameter: any) {
        return new StringViewModel(this.parent);
    }
    visitListType(arg0: ListType, parameter: any) {
        return new ListViewModel(this.parent);
    }
    visitClassType(arg0: ClassType, parameter: any) {
        return new ClassViewModel(this.parent);
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return new ClassViewModel(this.parent);
    }
    visitVoidType(arg0: VoidType, parameter: any) {
        throw new Error("Method not implemented.");
    }
    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return new ServerSideDataLoaderViewModel(this.parent);
    }
    visitDateType(arg0: DateType, parameter: any) {
        return new DateTimeViewModel(this.parent);
    }
   
}